/**
 * Image content type
 * @constructor
 */
class MediaImage {
    constructor(filename, duration) {

        this.duration = duration * 1000;
        this.container = $("<div>").appendTo("#preview-container");
        this.container.addClass("container_preloading");
        this.container.css({
            backgroundImage: "url('" + filename + "')",
            backgroundPosition: "center center",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat"
        });
    }

    /**
     * Start playback
     */
    start() {
        return new Promise(resolve => {
            try {
                console.log("Start playback");
                this.container.removeClass("container_preloading").addClass("container_playing");
                if (this.duration !== 0) {
                    setTimeout(() => resolve("Finished playback"), this.duration);
                }
            } catch (e) {
                console.error("MediaImage start error: " + e.message);
                resolve("Finished playback");
            }
        });
    };

    /**
     * Stop playback
     */
    stop() {
        try {
            this.container.css("backgroundImage", "none").remove();
        } catch (e) {
            console.error("MediaImage stop error: " + e.message);
        }
    };
}

/**
 * Web page
 * @param filename
 * @param duration
 * @constructor
 */
class MediaWebPage {
    constructor(filename, duration) {
        this.duration = duration * 1000;
        this.container = $("<iframe>").appendTo("#preview-container");
        this.container.addClass("container_preloading");
        this.container.attr("src", filename);

    }
    /**
     * Start playback
     */
    start() {
        return new Promise(resolve => {
            try {
                console.log("Start playback");
                this.playing = true;
                this.container.removeClass("container_preloading").addClass("container_playing");
                if (this.duration !== 0) {
                    setTimeout(() => resolve("Finished playback"), this.duration);
                }
            } catch (e) {
                console.error("MediaWebPage start error: " + e.message);
                resolve("Finished playback");
            }
        });
    };

    /**
     * Stop playback
     */
    stop() {
        try {
            this.container.remove();
        } catch (e) {
            console.error("MediaWebPage stop error: " + e.message);
        }
    };
}

/**
 * Video content type
 * @constructor
 */
class MediaVideo {
    constructor(filename, duration) {
        try {
            this.duration = duration * 1000;

            const video = document.createElement("video");
            video.preload = "auto";
            video.muted = true;
            video.loop = true;
            video.src = filename;
            // video.load();
            video.classList.add("container_preloading");
            document.body.querySelector("#preview-container").appendChild(video);

            this.container = video;
        } catch (e) {
            console.error("MediaVideo init error: " + e.message);
        }
    }
    /**
     * Start playback
     */
    start() {
        return new Promise(resolve => {
            try {
                console.log("Start playback");
                this.container.classList.remove("container_preloading");
                this.container.classList.add("container_playing");
                this.container.play();
                if (this.duration !== 0) {
                    setTimeout(() => resolve("Finished playback"), this.duration);
                }
            } catch (e) {
                console.error("MediaVideo start error: " + e.message);
                resolve("Finished playback");
            }
        });
    };

    /**
     * Stop playback
     */
    stop() {
        this.container.pause();
        this.container.remove();
    };
}
